import { browser } from "$app/environment";

// One in-flight request per page load, shared by every caller.
let pending = null;

/**
 * Resolve whether this visitor's region requires opt-in consent before
 * marketing trackers may load.
 *
 * On prerendered routes the server-rendered value is a build-time default
 * (`true`), not a real geo evaluation, so it cannot be trusted. `/api/consent-
 * region` is a server function and does see the request, so its answer wins.
 * The server value stays the fallback: it is already correct on the routes that
 * opt out of prerendering, and it is the privacy-safe answer if the fetch
 * fails.
 *
 * @param {boolean} serverValue - `requiresCookieConsent` from the layout data.
 * @returns {Promise<boolean>}
 */
export function resolveConsentRegion(serverValue) {
  if (!browser) return Promise.resolve(serverValue);

  if (!pending) {
    const query = new URLSearchParams(window.location.search).get("region");
    const suffix = query ? `?region=${encodeURIComponent(query)}` : "";

    pending = fetch(`/api/consent-region${suffix}`, {
      headers: { accept: "application/json" },
    })
      .then((response) => (response.ok ? response.json() : null))
      .then((data) =>
        typeof data?.requiresConsent === "boolean"
          ? data.requiresConsent
          : serverValue,
      )
      .catch(() => serverValue);
  }

  return pending;
}
